<template>

  <div class="box-verify">
    <div class="box-preloader" v-if="!verifyStatus">
      <h1 class="title">
        Estamos verificando su correo electrónico
      </h1>
      <Preloader></Preloader>
    </div>
    <div class="box-success" v-else>
      <h1 class="title">Su cuenta ha sido verificada, puede iniciar sesión y comenzar a invertir en Cumplo.</h1>
      <CheckmarkOK></CheckmarkOK>
      <button class="button" @click.prevent="$router.push({ name: 'LogIn' })">Iniciar sesión</button>
    </div>
  </div>

</template>

<script>

import Preloader from '@/components/Preloader'
import CheckmarkOK from '@/components/CheckmarkOK'

import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'VerifyEmail',
  data () {
    return {
      verifyStatus: false,
      token: null
    }
  },
  metaInfo () {
    return {
      title: 'Verificar email'
    }
  },
  mixins: [httpRequestMixin],
  components: {
    Preloader,
    CheckmarkOK
  },
  methods: {
    sendUserVerifyEmail: async function (token) {
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/auth/confirm/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          'token': `${token}`
        }
      }
      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.verifyStatus = true
      } else {
        this.modalError(response.data.token, 'warning')
        this.$router.replace('/login')
      }
    }
  },
  created: function () {
    this.token = this.$route.params.token
    this.sendUserVerifyEmail(this.token)
  }
}

</script>

<style lang="scss" scoped>

.box-verify {
  margin-top: 10rem;
  padding: 10rem 0;
  min-height: 450px;

  .title {
    font-size: 1.6em;
    font-weight: 300;
    text-align: center;
  }
}

.box-success {
  text-align: center;

  .checkmark {
    margin: 5% auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/VerifyEmail.vue